import { useEffect, useRef } from 'react';
import { useDebouncedValue } from 'rooks';

export const getMoneyInputProps = (form, fieldName) => ({
  type: 'text',
  inputMode: 'decimal',
  pattern: '[0-9]*[.]?[0-9]*',
  step: '0.01',
  onKeyPress: (e) => {
    // Prevent non-numeric and non-decimal input
    if (!/[\d.]/.test(e.key) && e.key !== 'Backspace') {
      e.preventDefault();
      return;
    }

    const value = e.target.value;
    const decimalIndex = value.indexOf('.');

    // Prevent more than 2 decimal places
    if (
      decimalIndex !== -1 &&
      e.target.selectionStart > decimalIndex &&
      value.substring(decimalIndex + 1).length >= 2
    ) {
      e.preventDefault();
    }

    // Prevent multiple decimal points
    if (e.key === '.' && value.includes('.')) {
      e.preventDefault();
    }
  },
  onPaste: (e) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData('text');
    const cleanedText = pastedText.replace(/[^\d.]/g, '');

    // Only allow one decimal point and max 2 decimal places
    const parts = cleanedText.split('.');
    const sanitizedText =
      parts[0] + (parts.length > 1 ? '.' + parts[1].substring(0, 2) : '');

    // Insert at cursor position
    const input = e.target;
    const value = input.value;
    const start = input.selectionStart;
    const end = input.selectionEnd;
    const newValue =
      value.substring(0, start) + sanitizedText + value.substring(end);

    // If result would have more than 2 decimal places, truncate
    const finalValue = newValue.includes('.')
      ? newValue.split('.')[0] + '.' + newValue.split('.')[1].substring(0, 2)
      : newValue;

    form.setValue(fieldName, finalValue, { shouldValidate: true });
  }
});

export const useDebouncedFormSubmit = (
  form,
  key,
  onSubmit,
  debounceRate = 250
) => {
  const value = form.watch(key);
  const initialRef = useRef(value);
  const [debouncedValue] = useDebouncedValue(value, debounceRate);

  useEffect(() => {
    if (debouncedValue !== initialRef.current) {
      form.handleSubmit(onSubmit)();
      initialRef.current = debouncedValue;
    }
  }, [debouncedValue, form, onSubmit]);
};
